module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBoldItalic.62d331b.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-SemiBoldItalic.woff
// module id = /V9V
// module chunks = 3